/* eslint-disable import/extensions,global-require,no-console */
/* eslint-disable no-param-reassign */
import { UiFlags } from '@tassat/common-definitions';
import { browserLocalStore, browserSessionStore } from '@tassat/utility';
import * as jwt from 'jsonwebtoken';
import { v4 as uuidv4 } from 'uuid';

import adminStore from 'Reducers/store/adminStore';
import clientStore from 'Reducers/store/clientStore';

import RealtimeHandler from './RealtimeHandler';
import { AdminMessaging, ClientMessaging, Messaging } from '../platform-api/messaging';
import uiManager from '../UiManager';

const store = import.meta.env.UI_TYPE === 'admin' ? adminStore : clientStore;

export default class WebWorker {
    constructor() {
        if (!window.primusInstance) {
            window.primusInstance = new Worker(new URL('./PrimusWrapper.ts', import.meta.url), { type: 'module' });
        }
        const token = browserSessionStore.getItem('id_token');
        const decodedToken = jwt.decode(token) || {};
        const authDetails = {
            userId: browserSessionStore.getItem('userid'),
            isAdmin: browserSessionStore.getItem('is_admin')
        };
        this.instance = window.primusInstance;
        this.handler = RealtimeHandler(this.instance, this, store);
        this.instance.addEventListener('message', this.handler);
        this.instance.addEventListener('error', console.error);
        //send data to primus webworker to be set to its context
        this.instance.postMessage({
            type: 'open',
            data: {
                token,
                authDetails,
                noEncryptDataExchangeFlagExists:
          browserLocalStore.includes(UiFlags.NO_DATA_EXCHANGE_ENCRYPTION) &&
          browserLocalStore.getItem(UiFlags.NO_DATA_EXCHANGE_ENCRYPTION) === decodedToken.sub
            }
        });
        this.promiseMap = {};
        const baseFunctions = Object.getOwnPropertyNames(Messaging.prototype);
        const adminFunctions = Object.getOwnPropertyNames(AdminMessaging.prototype);
        const clientFunctions = Object.getOwnPropertyNames(ClientMessaging.prototype);
        const functions = new Set(baseFunctions.concat(adminFunctions.concat(clientFunctions)));

        this.send = this.send.bind(this);
        this.log = this.log.bind(this);
        this.endSession = this.endSession.bind(this);
        functions.forEach((func) => {
            if (func === 'constructor' || func === 'endSession') {
                return;
            }
            this[func] = (...args) => {
                const id = uuidv4();
                console.debug('Invoking command', id, func, args);
                const command = {
                    method: func,
                    id,
                    args
                };
                const promise = new Promise((resolve, reject) => {
                    this.promiseMap[id] = {
                        resolve,
                        reject,
                        command
                    };
                });
                this.send({ commandData: command });

                return promise;
            };
        });
    }

    static getInstance() {
        uiManager.initializeWindowInterface();

        if (!window.primusInstance) {
            // New Worker Instance created
            window.primusInstance = new WebWorker();
        }

        return window.primusInstance;
    }

    resolve(response) {
        this.promiseMap[response.command.id].resolve(response);
    }

    log(data) {
        try {
            if (this.instance) {
                this.instance.postMessage({
                    type: 'log',
                    data
                });
            }
        } catch (e) {
            console.error(e);
        }
    }
    send(data) {
        try {
            if (this.instance) {
                this.instance.postMessage({
                    type: 'command',
                    data
                });
            }
        } catch (e) {
            console.error(e);
        }
    }
    endSession() {
        try {
            if (this.instance) {
                this.instance.postMessage({ type: 'endSession' });
            }
        } catch (e) {
            console.error(e);
        }
    }
}